import * as i from 'io-ts';
/**
 * The option name, e.g. VanityUnit:Width or BasinTap:Finish
 *
 * used to indicate the option being selected
 */
export const Name = i.string;
/**
 * The value of the option associated with the name
 */
export const Value = i.union([i.string, i.number, i.null]);
/**
 * Represents an aspect of a particular product
 *  or particle associated with a product.
 *
 * The name is expected to be locally unique, and is used to
 *  associate the item with other items with the same named option.
 * For example, a collection of items might all have an option
 * with the name VanityUnit:Width where each of the values are different.
 * This provides us possible ways of differentiating between these items
 * when choosing based on this option name.
 *
 * @deprecated - Consider using the Effect Schema version used by the Effect Service '3dxConfigurationService'
 */
export const Option = i.type({
    name: Name,
    value: Value,
});
